import { render, staticRenderFns } from "./PatternTab.vue?vue&type=template&id=64c9cf5a&scoped=true"
import script from "./PatternTab.vue?vue&type=script&lang=js"
export * from "./PatternTab.vue?vue&type=script&lang=js"
import style0 from "./PatternTab.vue?vue&type=style&index=0&id=64c9cf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9cf5a",
  null
  
)

export default component.exports